// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {WBSelect} from '@wandb/weave/common/components/WBSelect';
import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {GLOBAL_COLORS} from '../../../util/colors';
import {REPORT_FONT_SIZE} from '../constants';

export const LanguageSelect = styled(WBSelect)`
  position: absolute;
  top: 4px;
  right: 4px;
  justify-content: flex-end;
  width: 124px;
  background: ${globals.gray50};
`;

export const CodeBlockWrapper = styled.div`
  position: relative;
  ${LanguageSelect} {
    opacity: 0;
    transition: opacity 0.15s;
  }
  &:hover {
    ${LanguageSelect} {
      opacity: 0.85;
    }
  }

  // HACK(WB-4910): Avoid page breaks during PDF export. Must use
  // 'report-width-print-*' selectors so this element can be detected by re-
  // positioning logic run during export.
  .report-width-print-portrait &,
  .report-width-print-landscape & {
    break-inside: avoid;
    page-break-inside: avoid;
  }
`;

export const CodeBlock = styled.pre`
  border-radius: 2px;
  font-family: Inconsolata, Consolas, monospace;
  background: ${globals.gray50};
  border: 1px solid ${GLOBAL_COLORS.outline.toString()};
  padding: 8px 12px;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: ${Math.round(REPORT_FONT_SIZE * 0.8)}px;
  overflow-x: auto;
`;
